import { render, staticRenderFns } from "./DeleteFAQ.vue?vue&type=template&id=dde5fa00&"
import script from "./DeleteFAQ.vue?vue&type=script&lang=js&"
export * from "./DeleteFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports